<template>
  <div>
    <div class="l-main-content">
      <div class="p-project-edit p-project-edit--readonly">
        <div class="c-title">
          <div class="c-title__text u-fs24">{{ title }}</div>
        </div>
        <ul class="p-project-edit-list">
          <!-- AccessToken -->
          <li class="p-project-edit-list__item">
            <div class="p-project-edit-list__title">
              トラッキングID
            </div>
            <div class="p-project-edit-list__text">
              {{ data.key }}
            </div>
          </li>
          <!-- /AccessToken -->
          <!-- スクリプトタグ -->
          <li class="p-project-edit-list__item">
            <div class="c-textarea">
              <div class="c-textarea__title">スクリプトタグ</div>
              <textarea
                :value="data.script"
                style="margin-left: auto"
                class="c-textarea__item u-w630 u-h126"
                :name="copyId"
                readonly
              ></textarea>
              <div class="c-textarea__text c-textarea__text--spec c-text">
                <p>
                  ※タグは各種タグマネージャーで設置可能ですので、お使いのタグマネージャー
                </p>
                <p>
                  （GoogleTagManagerなど）でも設置可能です。詳しい導入方法は<a
                    style="text-decoration: underline;"
                    target="_blank"
                    href="https://manual.webpush.jp/posts/initialsetting-tag-gtm"
                  >こちら</a>
                </p>
              </div>
              <button
                class="c-btn c-btn--circle"
                type="button"
                name="clip"
                value="add-user"
                @click="onClipClick($event)"
              >
                <div
                  v-tooltip="{
                    content: isCopied
                      ? 'コピーしました'
                      : 'クリップボードにコピー',
                    hideTriggers: (triggers) => triggers.filter((trigger) => trigger !== 'click'),
                  }"
                  @click="toggleCopyText"
                >
                  <div class="c-icon-circle c-icon-circle--gray-2 u-wh40">
                    <div
                      class="c-icon-circle__item c-icon-circle__item--white c-icon__item--alpha70 u-wh20"
                    >
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <use xlink:href="/assets/img/sprite.svg#clipboard" />
                      </svg>
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </li>
          <!-- /スクリプトタグ -->
        </ul>
        <!-- /入力 | 選択リスト -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    data: {
      type: Object,
      default: () => ({})
    },
    copyId: String,
  },
  data() {
    return { isCopied: false };
  },
  methods: {
    onClipClick: function (event) {
      // ブラウザデフォルトイベントを停止
      event.preventDefault();

      // 埋め込みタグの文字列をコピー
      let text = $(`textarea[name="${this.copyId}"]`).prop("value");

      this.$copyText(text).then(
        function (_e) { },
        function (_e) { }
      );
    },
    toggleCopyText: function () {
      this.isCopied = true;
      setTimeout(() => {
        this.isCopied = false;
      }, 2000);
    },
  },
};
</script>
